import { PrepNote } from '@akin-home/recipes';
import React, { FC } from 'react';
import { StyleSheet, ViewProps } from 'react-native';
import styled from 'styled-components/native';
import PreparationStepGridItem from './PreparationStepGridItem';

interface Props extends ViewProps {
  steps?: PrepNote[];
}

const PreparationStepsGrid: FC<Props> = (props) => {
  const { steps = [] } = props;

  return steps.length > 0 ? (
    <Grid>
      {steps.map((step, idx) => (
        <PreparationStepGridItem
          key={step.id}
          step={step}
          number={idx + 1}
          style={styles.item}
        />
      ))}
    </Grid>
  ) : null;
};

const Grid = styled.View`
  flex-direction: row;
  flex-wrap: wrap;
  gap: 40px;
  width: 100%;
`;

const styles = StyleSheet.create({
  item: {
    width: '100%',
    maxWidth: 300,
  },
});

export default PreparationStepsGrid;
